/**
 * Collection grid SPU pin via ?products=SPU1,SPU2
 * Gathers paginated cards, pins matches first, hides pagination in pin mode.
 */
(function () {
  var APPLYING = false;

  function parsePinOrder() {
    var raw = new URLSearchParams(window.location.search).get('products');
    if (!raw) return [];
    var seen = Object.create(null);
    var order = [];
    String(raw)
      .split(',')
      .forEach(function (part) {
        var spu = String(part || '')
          .trim()
          .toUpperCase();
        if (!spu || seen[spu]) return;
        seen[spu] = true;
        order.push(spu);
      });
    return order;
  }

  function pinKey(pinOrder) {
    return window.location.pathname + '?' + pinOrder.join(',');
  }

  function buildParamsForPage(page, sectionId) {
    var params = new URLSearchParams(window.location.search);
    params.delete('products');
    if (!page || page <= 1) params.delete('page');
    else params.set('page', String(page));
    params.set('sections', sectionId);
    return params;
  }

  function fetchSectionPage(sectionId, page) {
    var url = window.location.pathname + '?' + buildParamsForPage(page, sectionId).toString();
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (json) {
        if (!json) return null;
        return json[sectionId] || null;
      })
      .catch(function () {
        return null;
      });
  }

  function collectItemsFromRoot(root, into, seenHandle) {
    var list = root.querySelector('[data-kik-spu-pin-list]') || root.querySelector('#items-grid');
    if (!list) return 0;
    var count = 0;
    Array.prototype.forEach.call(list.querySelectorAll('[data-product-handle]'), function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle || seenHandle[handle]) return;
      seenHandle[handle] = true;
      into.push({
        handle: handle,
        spu: String(el.getAttribute('data-spu') || '')
          .trim()
          .toUpperCase(),
        el: el,
      });
      count += 1;
    });
    return count;
  }

  function applyPin(container) {
    if (!container || APPLYING) return Promise.resolve();

    var pinOrder = parsePinOrder();
    if (!pinOrder.length) return Promise.resolve();

    var key = pinKey(pinOrder);
    if (container.getAttribute('data-kik-spu-applied') === key) return Promise.resolve();

    var sectionId = container.getAttribute('data-kik-spu-section-id');
    var pageSize = parseInt(container.getAttribute('data-kik-spu-page-size') || '20', 10) || 20;
    var grid = container.querySelector('[data-kik-spu-pin-list]') || container.querySelector('#items-grid');
    if (!sectionId || !grid) return Promise.resolve();

    APPLYING = true;
    container.classList.add('kik-cgrid--spu-pinning');

    var items = [];
    var seenHandle = Object.create(null);
    var page1Count = collectItemsFromRoot(container, items, seenHandle);
    var hasPager = !!container.querySelector('.kik-cgrid__pagination');
    var shouldFetchMore = hasPager || page1Count >= pageSize;

    var chain = Promise.resolve();
    if (shouldFetchMore) {
      var page = 2;
      var fetchNext = function () {
        if (page > 20) return Promise.resolve();
        return fetchSectionPage(sectionId, page).then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sectionRoot =
            doc.getElementById('shopify-section-' + sectionId) ||
            doc.querySelector('[data-kik-spu-pin]') ||
            doc;
          var n = collectItemsFromRoot(sectionRoot, items, seenHandle);
          if (n < pageSize) return;
          page += 1;
          return fetchNext();
        });
      };
      chain = fetchNext();
    }

    return chain
      .then(function () {
        var bySpu = Object.create(null);
        items.forEach(function (it) {
          if (it.spu && !bySpu[it.spu]) bySpu[it.spu] = it;
        });

        var pinned = [];
        var pinnedHandles = Object.create(null);
        pinOrder.forEach(function (spu) {
          var it = bySpu[spu];
          if (!it || pinnedHandles[it.handle]) return;
          pinned.push(it);
          pinnedHandles[it.handle] = true;
        });

        container.setAttribute('data-kik-spu-applied', key);
        if (!pinned.length) return;

        var rest = items.filter(function (it) {
          return !pinnedHandles[it.handle];
        });

        grid.innerHTML = '';
        pinned.concat(rest).forEach(function (it) {
          grid.appendChild(it.el);
        });

        var pager = container.querySelector('.kik-cgrid__pagination');
        if (pager) pager.style.display = 'none';
      })
      .finally(function () {
        container.classList.remove('kik-cgrid--spu-pinning');
        APPLYING = false;
      });
  }

  function runAll() {
    if (!parsePinOrder().length) return;
    document.querySelectorAll('[data-kik-spu-pin]').forEach(function (el) {
      applyPin(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-kik-spu-pin]').forEach(function (el) {
      el.removeAttribute('data-kik-spu-applied');
    });
    runAll();
  });

  // Re-apply after filter/sort AJAX replaces the grid.
  var obsTimer = null;
  function bindObserver() {
    document.querySelectorAll('[data-kik-spu-pin]').forEach(function (el) {
      if (el._kikSpuObs) return;
      el._kikSpuObs = true;
      var observer = new MutationObserver(function () {
        if (!parsePinOrder().length || APPLYING) return;
        el.removeAttribute('data-kik-spu-applied');
        clearTimeout(obsTimer);
        obsTimer = setTimeout(runAll, 120);
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }
  bindObserver();
  document.addEventListener('shopify:section:load', bindObserver);
})();
